import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'antd';
import i18n from 'react-intl-universal';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Doyle from '@jianshu/doyle';
import _ from 'lodash';
import $ from 'jquery';

import styles from './PreviewWrapper.scss';

import { switchSyncScroll } from '../../actions/UserAction';
import { getState as getUserState } from '../../reducers/User/UserReducer';

import Message from '../../components/Message';
import PreviewRoot from '../../components/PreviewVDOM/PreviewRoot';
import { getVNodes } from '../../utils/vdom';

const doyle = new Doyle();
// 添加行数
doyle.md.renderer.rules.paragraph_open = (tokens, idx) => {
  if (tokens[idx].tight) {
    return '';
  }
  if (tokens[idx].lines && tokens[idx].level === 0) {
    const line = tokens[idx].lines[0];
    return `<p class="line" data-line="${line}">`;
  }
  return '<p>';
};
doyle.md.renderer.rules.heading_open = (tokens, idx) => {
  if (tokens[idx].lines && tokens[idx].level === 0) {
    const line = tokens[idx].lines[0];
    return `<h${tokens[idx].hLevel} class="line" data-line="${line}">`;
  }
  return `<h${tokens[idx].hLevel}>`;
};

@connect(
  state => ({
    sync: !!getUserState(state).getIn(['user', 'md_auto_scroll']),
  }),
  dispatch => ({
    switchSyncScroll: on => dispatch(switchSyncScroll(on)),
  }),
)
export default class PreviewWrapper extends Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    sync: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.scrollMap = null;
    this.syncResultScroll = _.debounce(this.syncResultScroll.bind(this), 50, { maxWait: 50 });
    this.syncSrcScroll = _.debounce(this.syncSrcScroll.bind(this), 50, { maxWait: 50 });
  }

  componentDidMount() {
    this.showMessage();
    if (this.props.sync) {
      this.startSyncScroll();
    }
  }

  shouldComponentUpdate(nextProps) {
    return !(nextProps.content === this.props.content && nextProps.sync === this.props.sync);
  }

  componentDidUpdate() {
    this.clearScrollMap();
    if (this.props.sync) {
      this.startSyncScroll();
    } else {
      this.cancelSyncScroll();
    }
  }

  componentWillUnmount() {
    this.cancelSyncScroll();
  }

  startSyncScroll = () => {
    window.addEventListener('resize', this.clearScrollMap);
    document.querySelector('.source').addEventListener('mouseover', this.sourceMouseEnterHandler);
    document.querySelector('.result-html').addEventListener('mouseover', this.resultMouseEnterHandler);
  };

  // 取消同步滚动
  cancelSyncScroll = () => {
    this.clearScrollMap();
    window.removeEventListener('resize', this.clearScrollMap);
    document.querySelector('.source').removeEventListener('mouseover', this.sourceMouseEnterHandler);
    document.querySelector('.result-html').removeEventListener('mouseover', this.resultMouseEnterHandler);
    document.querySelector('.source').removeEventListener('scroll', this.syncResultScroll);
    document.querySelector('.result-html').removeEventListener('scroll', this.syncSrcScroll);
  };

  // 鼠标移入source时
  sourceMouseEnterHandler = () => {
    document.querySelector('.source').addEventListener('scroll', this.syncResultScroll);
    document.querySelector('.result-html').removeEventListener('scroll', this.syncSrcScroll);
  };

  // 鼠标移入result时
  resultMouseEnterHandler = () => {
    document.querySelector('.source').removeEventListener('scroll', this.syncResultScroll);
    document.querySelector('.result-html').addEventListener('scroll', this.syncSrcScroll);
  };

  clearScrollMap() {
    this.scrollMap = null;
  }

  // eslint-disable-next-line class-methods-use-this
  buildScrollMap() {
    const textarea = $('.source');
    const resultElement = document.querySelector('.result-html');
    const sourceLikeDiv = $('<div/>').css({
      position: 'absolute',
      visibility: 'hidden',
      height: 'auto',
      width: textarea[0].clientWidth,
      'font-size': textarea.css('font-size'),
      'font-family': textarea.css('font-family'),
      'line-height': textarea.css('line-height'),
      'white-space': textarea.css('white-space'),
    }).appendTo('body');

    // const offset = resultHtml.scrollTop() - resultHtml.offset().top;
    const offset = 0;
    // eslint-disable-next-line no-underscore-dangle
    const _scrollMap = [];
    const nonEmptyList = [];
    const lineHeightMap = [];

    let acc = 0;
    textarea.val().split('\n').forEach((str) => {
      lineHeightMap.push(acc);

      if (str.length === 0) {
        acc++;
        return;
      }

      sourceLikeDiv.text(str);
      const h = parseFloat(sourceLikeDiv.css('height'));
      const lh = parseFloat(sourceLikeDiv.css('line-height'));
      acc += Math.round(h / lh);
    });
    sourceLikeDiv.remove();
    lineHeightMap.push(acc);
    const linesCount = acc;

    for (let i = 0; i < linesCount; i++) {
      _scrollMap.push(-1);
    }

    nonEmptyList.push(0);
    _scrollMap[0] = 0;

    Array.prototype.forEach.call(document.querySelectorAll('.line'), (el) => {
      let t = el.getAttribute('data-line');
      if (t === '') {
        return;
      }
      t = lineHeightMap[t];
      if (t !== 0) {
        nonEmptyList.push(t);
      }
      _scrollMap[t] = Math.round(el.offsetTop + offset);
    });

    nonEmptyList.push(linesCount);
    _scrollMap[linesCount] = resultElement.scrollHeight;

    let pos = 0;
    for (let i = 1; i < linesCount; i++) {
      if (_scrollMap[i] !== -1) {
        pos++;
        // eslint-disable-next-line no-continue
        continue;
      }

      const a = nonEmptyList[pos];
      const b = nonEmptyList[pos + 1];
      // eslint-disable-next-line no-mixed-operators
      _scrollMap[i] = Math.round((_scrollMap[b] * (i - a) + _scrollMap[a] * (b - i)) / (b - a));
    }
    return _scrollMap;
  }

  syncResultScroll() {
    const textarea = $('.source');
    const lineHeight = parseFloat(textarea.css('line-height'));
    const lineNo = Math.floor(textarea.scrollTop() / lineHeight);
    this.scrollMap = this.scrollMap ? this.scrollMap : this.buildScrollMap();
    const posTo = this.scrollMap[lineNo];

    $('.result-html').stop(true).animate({
      scrollTop: posTo - 65,
    }, 100, 'linear');
  }

  syncSrcScroll() {
    const textarea = $('.source');
    const resultHtml = $('.result-html');
    const lineHeight = parseFloat(textarea.css('line-height'));
    const scrollTop = resultHtml.scrollTop();
    this.scrollMap = this.scrollMap ? this.scrollMap : this.buildScrollMap();
    const lines = Object.keys(this.scrollMap);

    if (lines.length < 1) {
      return;
    }

    let line = lines[0];

    for (let i = 1; i < lines.length; i++) {
      if (this.scrollMap[lines[i]] < scrollTop) {
        line = lines[i];
        // eslint-disable-next-line no-continue
        continue;
      }
      break;
    }

    textarea.stop(true).animate({
      scrollTop: lineHeight * line,
    }, 100, 'linear');
  }

  showMessage = () => {
    setTimeout(() => {
      Message.info(i18n.get('global.quit'));
    }, 0);
  };

  getHTML = () => {
    const { content } = this.props;
    return doyle.parse(content);
  };

  switchSyncState = (on) => {
    this.props.switchSyncScroll(on);
  };

  render() {
    const { sync } = this.props;
    const html = this.getHTML();
    const contentClass = classNames({
      'note-view': true,
      [`${styles['content']}`]: true,
    });

    return (
      <Fragment>
        <div className={styles['sync-switch']}>
          <span className={styles['sync-switch-text']}>{i18n.get('settings.sync-scroll')}：</span>
          <Switch
            checked={sync}
            checkedChildren={i18n.get('settings.on')}
            unCheckedChildren={i18n.get('settings.off')}
            size={'small'}
            onChange={this.switchSyncState}
          />
        </div>
        <div className={contentClass}>
          <PreviewRoot nodes={getVNodes(html)}/>
        </div>
      </Fragment>
      /*
       <div
       className={contentClass}
       dangerouslySetInnerHTML={{ __html: html }}
       />
       */
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PreviewWrapper/PreviewWrapper.js